import { render } from "./ProjectOverviewExpense.vue?vue&type=template&id=64ff2f8e"
import script from "./ProjectOverviewExpense.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__